import React, { useRef, useState } from 'react'
import { isIE } from 'shared/helpers'

import { css, Global } from '@emotion/react'
import { t, Trans } from '@lingui/macro'

import { Box } from 'front-end/src/components'
import { useLooopTheme } from '../../../public-api/hooks/useLooopTheme'
import { ButtonIcon } from '../../common/form/button/ButtonChakra'
import IconClose from '../../common/icon/IconClose'

const optOutSessionStorageKey = 'ieWarningHide'
const heightOfPanelDefault = 46

const IEWarningPopup = () => {
  const { theme } = useLooopTheme()
  const elementRef = useRef(null)

  const [showIeBanner, setShowIeBanner] = useState(true)
  const [heightOfPanel, setHeightOfPanel] = useState(heightOfPanelDefault)

  const optOut = sessionStorage?.getItem(optOutSessionStorageKey)
  const showBanner = isIE && showIeBanner && !optOut

  const onClose = () => {
    sessionStorage?.setItem(optOutSessionStorageKey, 'true')
    setShowIeBanner(false)
  }

  const handleResize = () => {
    // @ts-expect-error
    setHeightOfPanel(elementRef.current.clientHeight ?? heightOfPanelDefault)
  }
  showBanner && window.addEventListener('resize', handleResize, false)

  return showBanner ? (
    <>
      {/* Affect position of Main header and content below */}
      <Global
        styles={css`
          header.MainHeader {
            top: ${heightOfPanel}px;
          }
          .reactSpring__transition__wrapper {
            margin-top: ${80 + heightOfPanel}px;
            height: calc(100% - 80px - ${heightOfPanel}px - 1px);
          }
        `}
      />
      <Box
        ref={elementRef}
        className="ie-warning"
        position="fixed"
        top={0}
        left={0}
        width="100%"
        textAlign="center"
        bg={theme.colors.yellow[100]}
        boxShadow="0 0 4px rgba(0, 0, 0, 0.2)"
        color={theme.colors.grey.dark}
        zIndex={5001}
        p="12px 42px"
      >
        <Trans>
          This browser is no longer supported. Please update your browser for
          best viewing experience.
        </Trans>
        <ButtonIcon
          aria-label={t`Close`}
          onClick={onClose}
          size="sm"
          fontSize="18px"
          position="absolute"
          right="8px"
          top="8px"
          ml="8px"
          css={css`
            .icon {
              font-size: 18px;
              position: relative;
              top: 4px;
              left: -4px;
            }
          `}
        >
          <IconClose />
        </ButtonIcon>
      </Box>
    </>
  ) : null
}

export default IEWarningPopup
